import {Popup,Switch,Button} from "./";
import { ButtonSize,Icons,ButtonColor } from "@/enums";
import {useEffect} from "react";
import CookieConcentPdf from "@/assets/pdfs/cookie_policy.pdf";
import strings from "@/language/Swedish";
import * as Sentry from '@sentry/react';
import { activateSentry } from "@/helpers";
import { useAuth } from "@/context/AuthContext";
import gdprPDF from "@/assets/pdfs/gdpr.pdf";

export default function CookieConsent(){
    const {setHasCookies, setIsCookieConsentOpen, isCookieConsentOpen, hasSentry, setHasSentry} = useAuth();
    useEffect(() => {
      const hasConsent = localStorage.getItem("cookie_consent");
      const hasSentryConsent = localStorage.getItem("cookie_consent_sentry");

      if (!hasConsent) {
        setIsCookieConsentOpen(true);
      } else {
        setHasCookies(true);
      }

      if(hasSentryConsent === "true" && !hasSentry){
        setHasSentry(true);
      }
    }, []);

    function accept(){
      setIsCookieConsentOpen(false);
      localStorage.setItem("cookie_consent","true");
      localStorage.setItem("cookie_consent_sentry","true");
      setHasCookies(true);

      if (!hasSentry) {
        activateSentry();
        setHasSentry(true);
      }
    }

    function deny(){
      localStorage.setItem("cookie_consent","true");
      localStorage.setItem("cookie_consent_sentry","false");

      if(hasSentry){
        Sentry.close();
      }

      setIsCookieConsentOpen(false);
      setHasCookies(true);
      setHasSentry(false);
    }


    
    return (
        <Popup disabeled blur={true} contentPosition="center" isOpen={isCookieConsentOpen}>
        <div className="p-5 w-full md:w-[600px]">
          <h2>{strings.cookieConsent.title}</h2>
          <span className="text-slate">{strings.cookieConsent.description}<a href={CookieConcentPdf} target="_BLANK">{strings.cookieConsent.link}</a></span>
          <div className="flex flex-row gap-20 justify-center my-8 text-xs">
            <span>
              <b>{strings.cookieConsent.switchOptionalTitle}</b>
              <p>{strings.cookieConsent.switchOptionalDescription}</p>
            </span>
            <span>
              <b>{strings.cookieConsent.switchRequiredTitle}</b>
              <p>{strings.cookieConsent.switchRequiredDescription}</p>
            </span>
          </div>
          <div className="flex flex-row gap-20 justify-center my-8">
          <Switch value={false}/>
          <Switch value={true} disabled/>
          </div>
          <div>

          </div>
          <hr className="my-8"/>
          <span className="text-slate text-sm">{strings.cookieConsent.terms}<a href={gdprPDF} target="_BLANK">{strings.cookieConsent.termsLink}</a></span>
          <div className="flex flex-col sm:flex-row sm:gap-10 gap-4 justify-center mt-8">
            <Button
              icon={Icons.check}
              size={ButtonSize.extraLarge}
              color={ButtonColor.primary}
              onClick={accept}
            >{strings.cookieConsent.accept}</Button>
            <Button
              icon={Icons.cross}
              onClick={deny}
              size={ButtonSize.extraLarge}
              color={ButtonColor.warning}
            >{strings.cookieConsent.deny}</Button>
          </div>
        </div>
      </Popup>
    )
}